// src/components/Header.js
import React from 'react'
import {
    Space,
    Button,
    Tooltip,
    Row,
    Col,
} from "antd";

const Header = () => {

    // Vérifie si l'application est chargée dans une iframe
    const isInIframe = window.self !== window.top;

    // Si l'application est dans une iframe, ne pas afficher le footer
    if (isInIframe) {
        return null;
    }
    return (

        <header className="app-header">

            <div align="middle" justify="space-between" style={{width:'100%'}}>
                
                    <p className="app-title">Téléchargement des données LiDAR HD IGN</p>

                
            </div>

        </header>
    );
};

export default Header;